import { mergeStyleSets, getTheme } from "@fluentui/react";

const theme = getTheme();

export const styles = mergeStyleSets({
  // Command bar styles
  rolloutDetailsCommandBar: {
    borderBottom: `1px solid ${theme.palette.neutralLight}`,

    "& .ms-CommandBar": {
      justifyContent: "flex-start",
      paddingLeft: 10,
    },
  },

  // General container styles
  rolloutDetailsPanelContainer: {
    padding: "0 24px 24px 24px",
  },
  rolloutDetailsRoot: {
    background: theme.palette.white,
    borderRadius: "4px",
    border: `1px solid ${theme.palette.neutralLighter}`,
    flex: "0 0 auto",
  },

  rolloutDetailsAccordionClosed: {
    height: 50,
    maxHeight: 50,
  },
  rolloutDetailsAccordionPanel: {
    "& .fui-AccordionPanel": {
      margin: 0,
    },
  },
  rolloutDetailsAccordionHeader: {
    paddingTop: 15,
    paddingBottom: 5,
    "& .fui-AccordionHeader": {
      margin: 0,
    },
    "& .fui-AccordionHeader__button": {
      minHeight: 0,
    },
  },
  rolloutDetailsAccordionHeaderLabel: {
    paddingRight: 12,
  },
  rolloutDetailsAccordionHeaderLinks: {},
  configWarning: {
    color: theme.palette.redDark,
    margin: 10,
  },
});
